(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Always make header sticky and initialize transparency
      this.header.classList.add('shopify-section-header-sticky');
      this.initializeTransparency();

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    initializeTransparency() {
      // Set page attributes immediately for CSS targeting
      const isHomepage = window.location.pathname === '/' || 
                        document.body.classList.contains('template-index') ||
                        document.documentElement.classList.contains('template-index');
      
      document.body.setAttribute('data-pathname', window.location.pathname);
      if (isHomepage) {
        document.body.setAttribute('data-homepage', 'true');
      }

      // Initialize header transparency based on current scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateHeaderTransparency(scrollTop);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Handle transparency based on scroll position (0-100px range)
      this.updateHeaderTransparency(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateHeaderTransparency(scrollTop) {
      const headerWrapper = this.querySelector('.header-wrapper') || this;
      const transparencyThreshold = 100; // 100px threshold as requested
      const fadeOutThreshold = 120; // Additional 20px for smooth color transition
      
      // Check if we're on the homepage
      const isHomepage = window.location.pathname === '/' || 
                        document.body.classList.contains('template-index') ||
                        document.documentElement.classList.contains('template-index');

      // Handle announcement bar positioning
      this.updateHeaderPosition(scrollTop);

      // Set data-pathname attribute for CSS targeting
      if (!document.body.hasAttribute('data-pathname')) {
        document.body.setAttribute('data-pathname', window.location.pathname);
        // Also set homepage flag for immediate CSS application
        if (isHomepage) {
          document.body.setAttribute('data-homepage', 'true');
        }
      }

      // Only apply transparency effects on homepage
      if (isHomepage) {
        // Remove solid class if it exists from navigation between pages
        headerWrapper.classList.remove('header-solid');
        
        if (scrollTop <= fadeOutThreshold) {
          // Calculate opacity: 0 at scroll 0, 1 at scroll 100
          const opacity = Math.min(scrollTop / transparencyThreshold, 1);

          // Add transparent class and set CSS custom property for opacity
          headerWrapper.classList.add('header-transparent');
          headerWrapper.style.setProperty('--header-opacity', opacity);

          // For smooth color transition, gradually reduce the transparent effect after 100px
          if (scrollTop > transparencyThreshold) {
            const fadeOutProgress = (scrollTop - transparencyThreshold) / (fadeOutThreshold - transparencyThreshold);
            headerWrapper.style.setProperty('--color-fade-out', Math.min(fadeOutProgress, 1));
          } else {
            headerWrapper.style.setProperty('--color-fade-out', 0);
          }
        } else {
          // Remove transparent class and reset opacity
          headerWrapper.classList.remove('header-transparent');
          headerWrapper.style.removeProperty('--header-opacity');
          headerWrapper.style.removeProperty('--color-fade-out');
        }
      } else {
        // For non-homepage pages, ensure header always has solid background
        headerWrapper.classList.remove('header-transparent');
        headerWrapper.classList.add('header-solid');
        headerWrapper.style.removeProperty('--header-opacity');
        headerWrapper.style.removeProperty('--color-fade-out');
        
        // Ensure header height is set for MainContent margin
        this.setHeaderHeight();
      }
    }

    updateHeaderPosition(scrollTop) {
      const headerWrapper = this.querySelector('.header-wrapper') || this;
      const announcementBar = document.querySelector('.announcement-bar');

      if (announcementBar) {
        const announcementBarHeight = announcementBar.offsetHeight;

        // Calculate the announcement bar's current position relative to viewport
        const announcementBarRect = announcementBar.getBoundingClientRect();
        const announcementBarBottom = announcementBarRect.bottom;

        if (announcementBarBottom > 0) {
          // Announcement bar is still visible - stick header to its bottom
          headerWrapper.style.top = `${Math.max(0, announcementBarBottom)}px`;
        } else {
          // Announcement bar has scrolled completely out of view - header at top
          headerWrapper.style.top = '0px';
        }
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
